import React from 'react';

import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import SvgVerified from '../Icons/Verifed';

export default function VerifiedAccount({ verifiedAccount }: { verifiedAccount?: boolean }) {
  const { t } = useTranslation('common');
  return verifiedAccount ? (
    <Tooltip title={t('widgets.verifiedAccount')}>
      <SvgVerified className="verified-account-icon" />
    </Tooltip>
  ) : (
    <></>
  );
}
